<template>
  <div :class="{ 'purple-round-input input-wrapper': isUsingMetric, flex: !isUsingMetric }">
    <!-- Imperial with fields feet and inches -->
    <template v-if="!isUsingMetric">
      <div class="inline-flex purple-round-input input-wrapper">
        <input
          class="w-full h-12 outline-none"
          type="number"
          inputmode="numeric"
          v-model="ft"
          :placeholder="$t('settingUserData.your_height')"
          @input="onInput"
          @blur="emitInput"
        />
        <span class="unit-text">{{ $t('settingUserData.ft') }}</span>
      </div>
      <div class="inline-flex ml-3 purple-round-input input-wrapper">
        <input
          class="w-full h-12 outline-none"
          type="number"
          inputmode="numeric"
          v-model="inches"
          @input="onInput"
          @blur="emitInput"
        />
        <span class="unit-text">{{ $t('settingUserData.inch') }}</span>
      </div>
    </template>
    <template v-else>
      <input
        class="w-full h-12 outline-none"
        type="number"
        inputmode="numeric"
        v-model="cm"
        :placeholder="$t('settingUserData.your_height')"
        @input="onInput"
        @blur="emitInput"
      />
      <span class="unit-text">{{ $t('settingUserData.cm') }}</span>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

const RATIO = 2.54; // inch to cm

export default {
  name: 'Height',
  props: {
    value: Number,
  },
  data: vm => ({
    cm: vm.value,
    ft: null,
    inches: null,
  }),
  methods: {
    onInput() {
      if (!this.isUsingMetric) {
        this.toMetric();
      } else {
        this.toImperial();
      }
      this.emitInput();
    },
    emitInput() {
      this.$emit('input', Math.round(this.cm));
    },
    toImperial() {
      if (typeof this.cm === 'string') this.cm = this.cm.slice(0, 3);
      const cm = parseFloat(this.cm) || 0;
      const totalInches = cm / RATIO;
      this.ft = Math.floor(totalInches / 12);
      this.inches = Math.round(totalInches % 12);
    },
    toMetric() {
      if (typeof this.ft === 'string') this.ft = this.ft.slice(0, 1);
      if (typeof this.inches === 'string') this.inches = this.inches.slice(0, 2);
      const ft = parseFloat(this.ft) || 0;
      const inches = parseFloat(this.inches) || 0;
      const totalInches = ft * 12 + inches;
      this.cm = Math.round(totalInches * RATIO);
    },
    toggleUnit() {
      if (!this.isUsingMetric) {
        this.toImperial();
      } else {
        this.toMetric();
      }
      this.$nextTick(() => {
        this.emitInput();
      });
    },
  },
  computed: {
    ...mapGetters('app', ['isUsingMetric']),
    currentUnit() {
      return this.isUsingMetric ? this.$t('settingUserData.cm') : this.$t('settingUserData.inch');
    },
  },
  watch: {
    isUsingMetric() {
      this.toggleUnit();
    },
    value(nv, ov) {
      if (!ov && nv) {
        this.cm = nv;
        if (!this.isUsingMetric) {
          this.toImperial();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.input-wrapper {
  @apply pl-6 pr-2;
}
.unit-text {
  @apply text-xxs text-center font-medium opacity-50;
  color: var(--color-primary);
  white-space: nowrap;
}
</style>
